import { supabase } from '../supabase';

// Maps a `users` row (snake_case Postgres columns) to the camelCase shape
// every component already expects (matches the old Firestore doc fields) -
// keeps the migration to component read/render logic at zero, only the
// fetch call itself changes.
export function toProfileShape(row) {
  if (!row) return null;
  return {
    id: row.id,
    firstName: row.first_name || '',
    lastName: row.last_name || '',
    name: row.name || '',
    email: row.email || '',
    phone: row.phone || '',
    dob: row.dob || '',
    memberSince: row.member_since || '',
    memberId: row.member_id || '',
    points: row.points || 0,
    emailVerified: row.email_verified || false,
    createdAt: row.created_at || null,
  };
}

// Fetches the signed-in user's own `users` row by their Supabase Auth id.
export async function fetchOwnProfile(authUserId) {
  const { data, error } = await supabase
    .from('users')
    .select('*')
    .eq('auth_user_id', authUserId)
    .maybeSingle();
  if (error) throw error;
  return toProfileShape(data);
}
